import styled from "styled-components";

export const OptInDialogHeaderDefaultBox = styled.div`
    background-color: ${props => props.theme.colors.backgroundLight};
    padding: 10px 15px;
    min-height: 30px;
    width: 100%;
`;
